import { useState } from "react";
import { Col, Row, Tab, Nav } from "react-bootstrap";
import {
  loadLeapSearchOptionsAsync,
  selectLeapSearchOptions,
} from "../../redux/slices/search";
import BreadCrumbs from "./BreadCrumbs";
import Header from "./Header";
import useAppSelector from "../../hooks/useAppSelector";
import useAppDispatch from "../../hooks/useAppDispatch";
import Loading from "../../leap-components/Loading";
import BasicSearch from "./BasicSearch";
import AdvancedSearch from "./AdvancedSearch";
import HomeText from "./HomeText";

interface TabsWithTextLabelType {
  className?: string;
  activeKey: string;
  basicSearchContent: JSX.Element;
  advancedSearchContent: JSX.Element;
  homeContent: JSX.Element;
}

const LeapSearchTabs = ({
  className,
  activeKey,
  basicSearchContent,
  advancedSearchContent,
  homeContent,
}: TabsWithTextLabelType) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="basic-search">LEAP Search</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="advanced-search">Advanced Search</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="home-text">About LEAP</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="basic-search">{basicSearchContent}</Tab.Pane>
        <Tab.Pane eventKey="advanced-search">{advancedSearchContent}</Tab.Pane>
        <Tab.Pane eventKey="home-text">{homeContent}</Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const LeapHome = () => {
  const [loading, setLoading] = useState(false);

  const leapSearchOptionsSelector = useAppSelector(selectLeapSearchOptions);
  const dispatch = useAppDispatch();

  if (!loading) {
    setLoading(true);
    dispatch(loadLeapSearchOptionsAsync());
  }

  const authTypes = leapSearchOptionsSelector?.authorisationTypes;
  const sectorsList = leapSearchOptionsSelector?.sectorsList;
  const statusesList = leapSearchOptionsSelector?.licenseStatusesList;

  if (!authTypes || !sectorsList || !statusesList) {
    return <Loading />;
  }

  const basicSearchContent = <BasicSearch authorisationTypes={authTypes} />;
  const advancedSearchContent = (
    <AdvancedSearch
      authorisationTypes={authTypes}
      sectorsList={sectorsList}
      statusesList={statusesList}
    />
  );
  const homeContext = <HomeText></HomeText>;

  const contentElement = (
    <div>
      <Row>
        <Col className="col-12 col-sm-12 col-md-12">
          <LeapSearchTabs
            className="leapSearch"
            activeKey="basic-search"
            basicSearchContent={basicSearchContent}
            advancedSearchContent={advancedSearchContent}
            homeContent={homeContext}
          />
        </Col>
      </Row>
    </div>
  );

  return (
    <div>
      <BreadCrumbs />
      <div className="ps-0">
        <Header />
        {contentElement}
      </div>
    </div>
  );
};

export default LeapHome;
